export enum ColorButtonEnum {
    INHERIT = "inherit",
    PRIMARY = "primary",
    SECONDARY = "secondary",
    ERROR = "error",
    INFO = "info",
    SUCCESS = "success",
    WARNING = "warning",
}